import { CellStyle } from 'xlsx-js-style';
import { excelColors } from './excel-colors';


export const left: CellStyle = {
  alignment: { horizontal: 'left' },
};

export const leftIntend: any = {
  alignment: { horizontal: 'left', indent: 1 },
};

export const leftIntendNoBold: any = {
  alignment: { horizontal: 'left', indent: 1 },
  font: { bold: false },
};

export const centerNoBold: CellStyle = {
  alignment: { horizontal: 'center' },
};

export const centerLinkStyle: CellStyle = {
  alignment: { horizontal: 'center' },
  font: {
    color: { rgb: '0563C1' },
    underline: true,
  },
};

export const leftBold: CellStyle = {
  alignment: { horizontal: 'left' },
  font: { bold: true },
};

export const rightBold: CellStyle = {
  alignment: { horizontal: 'right' },
  font: { bold: true },
};


export const centeredBold: CellStyle = {
  alignment: { horizontal: 'center' },
  font: { bold: true },
};

export const leftBoldGrayForHeaders: CellStyle = {
  alignment: { horizontal: 'left' },
  font: { bold: true },
  fill: { fgColor: { rgb: 'F2F2F2' } },
};

export const centeredBoldGrayForHeaders: CellStyle = {
  alignment: { horizontal: 'center' },
  font: { bold: true },
  fill: { fgColor: { rgb: 'F2F2F2' } },
};

export const rightBoldGrayForHeaders: CellStyle = {
  alignment: { horizontal: 'right' },
  font: { bold: true },
  fill: { fgColor: { rgb: 'F2F2F2' } },
};


export const centeredBoldLightGrayBg: CellStyle = {
  font: { bold: true },
  fill: { fgColor: { rgb: 'sub_total_grey' } },
  alignment: { horizontal: 'center' },
};


export const center: CellStyle = {
  alignment: { horizontal: 'center' },
  font: { bold: true },
};

export const right: CellStyle = {
  alignment: { horizontal: 'right' },
  font: { bold: true },
};

export const rightNoBold: CellStyle = {
  alignment: { horizontal: 'right' },
  font: { bold: false },
};

export const boldGrayBgLeft: CellStyle = {
  font: { bold: true },
  fill: { fgColor: { rgb: excelColors.$subTotalGrey } },
  alignment: { horizontal: 'left' },
};

export const boldGrayBgLeftGrandTotal: CellStyle = {
  font: { bold: true },
  fill: { fgColor: { rgb: excelColors.$grandTotalGrey } },
  alignment: { horizontal: 'left' },
};

export const boldGrayBgCenter: CellStyle = {
  font: { bold: true },
  fill: { fgColor: { rgb: excelColors.$grandTotalGrey } },
  alignment: { horizontal: 'center' },
};

export const boldGrayBgRight: CellStyle = {
  font: { bold: true },
  fill: { fgColor: { rgb: excelColors.$grandTotalGrey } },
  alignment: { horizontal: 'right' },
};

export const boldLightGrayBgLeft: CellStyle = {
  font: { bold: true },
  fill: { fgColor: { rgb: excelColors.$subTotalGrey } },
  alignment: { horizontal: 'left' },
};

export const boldLightGrayBgRight: CellStyle = {
  font: { bold: true },
  fill: { fgColor: { rgb: excelColors.$subTotalGrey } },
  alignment: { horizontal: 'right' },
};

export const boldLightGrayBgCenter: CellStyle = {
  font: { bold: true },
  fill: { fgColor: { rgb: excelColors.$subTotalGrey } },
  alignment: { horizontal: 'center' },
};

export const boldBottomBorderThickTopThinRight: CellStyle = {
  font: { bold: true },
  alignment: { horizontal: 'right' },
  border: {
    top: { style: 'thin', color: { rgb: '000000' } },
    bottom: { style: 'thick', color: { rgb: '000000' } },
  },
};

// //////////////////////// KPI ///////////////////////

export const kpiPortfolioAnalysisFirsRowGreen: CellStyle = {
  alignment: { horizontal: 'center' },
  font: { bold: true, color: { rgb: 'FFFFFF' } },
  fill: { fgColor: { rgb: '00948E' } },
};

export const kpiPortfolioAnalysisFirsRowOrange: CellStyle = {
  alignment: { horizontal: 'center' },
  font: { bold: true, color: { rgb: 'FFFFFF' } },
  fill: { fgColor: { rgb: 'FB992F' } },
};

export const kpiHeaders: CellStyle = {
  font: { bold: true },
  fill: { fgColor: { rgb: excelColors.$grandTotalGrey } },
  alignment: { wrapText: true, horizontal: 'center', vertical: 'center' },
};

export const nullToDash = (v: number): any => (v ? v : '-');

export const zeroOrNullToEmptyString = (v: number): any => (!v ? '' : v);
